export default "__VITE_PUBLIC_ASSET__030bc511__"